import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import Home from './pages/Home';
import Treatments from './pages/Treatments';
import TreatmentDetail from './pages/TreatmentDetail';
import Prices from './pages/Prices';
import About from './pages/About';
import Contact from './pages/Contact';

export default function App() {
  return (
    <HelmetProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/behandlinger" element={<Treatments />} />
          <Route path="/behandlinger/:slug" element={<TreatmentDetail />} />
          <Route path="/priser" element={<Prices />} />
          <Route path="/om" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />
          {/* Catch-all redirect to home */}
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
    </HelmetProvider>
  );
}
